import React from 'react';
import { map } from 'ramda';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './BonusContent.scss';

function BonusContent({ horse }) {
    const body = horse.enhanced_bonus_content;
    let links = [];
    if (body) {
        if (body.indexOf(',') === -1) {
            links.push(body);
        } else {
            links = body.split(',');
            for (let i = 0; i <= links.length - 1; i++) {
                if (links[i].indexOf('>') === -1) {
                    let tempArr = [links[i], links[i +1]];
                    links[i] = tempArr.join(',');
                    links.splice(i + 1, 1);
                }
            }
        }    
    }

    // if (horse.youtube_url) {
    //     links.push(`Video>${horse.youtube_url}`);
    // }

    const linkTitlePairs = map(pair => pair.split('>'))(links);
    const outputButtons = map((link)=> {
        return (
            <div className="col-lg-12" key={link[0]}>
                <a href={link[1]} target="_blank">
                    <div className="bonus-content-link">
                        <p><FontAwesomeIcon style={{ verticalAlign:"middle" }} icon={['fas', 'star']} size='lg' />{' '}{link[0].replace(/(\r\n\t|\n|\r\t)/gm,"")}</p>
                    </div>
                </a>
            </div>
        );
    })(linkTitlePairs);

    return (
        <>
            {outputButtons}
        </>
    );
}

export default BonusContent;